'use es6';

const EMPTY_STATE = Object.freeze({
  codemirrorType: null
});
export default class CodemirrorManager {
  /**
   * Takes codemirror instance and props and handles registering the
   * status bar groups.
   *
   * @param {Object} options
   * @param {CodeMirror} options.codemirror
   * @param {Object} options.props
   */
  constructor(options) {
    this.destruct = () => {
      this.clearStatusBar();
      this.codemirror.off('focus', this.onFocus);
      window.removeEventListener('focus', this.onWindowFocus);
    };

    this.updateProps = nextProps => {
      if (!this.shouldUpdate(nextProps)) {
        return;
      }

      if (this.props.codemirrorType !== nextProps.codemirrorType) {
        this.onCodemirrorTypeChange();
      }

      this.props = nextProps;
    };

    this.onFocus = () => {
      this.initStatusBar();
    };

    this.onCodemirrorMount = () => {
      if (!this.codemirror.hasFocus()) return;
      this.props.registerStatusBar({
        codemirrorSessionId: this.props.sessionId
      });
    };

    this.onCodemirrorTypeChange = () => {
      if (!this.codemirror.hasFocus()) return;
      this.props.registerStatusBar({
        codemirrorType: this.props.codemirrorType
      });
    };

    this.onWindowFocus = () => {
      if (this.codemirror.hasFocus()) {
        // Push to the end of callstack to avoid race condition with other codemirror instances
        // that will be clearing the statusbar.
        setTimeout(() => this.initStatusBar(), 0);
      } else {
        this.clearStatusBar();
      }
    };

    this.codemirror = options.codemirror;
    this.props = options.props;
    this.initStatusBar();
    this.codemirror.on('focus', this.onFocus);
    window.addEventListener('focus', this.onWindowFocus);
  }

  shouldUpdate(nextProps) {
    const {
      props
    } = this;
    return !(props.codemirrorType === nextProps.codemirrorType && props.registerStatusBar === nextProps.registerStatusBar && props.sessionId === nextProps.sessionId);
  }

  initStatusBar() {
    if (!this.codemirror.hasFocus()) return;
    this.props.registerStatusBar({
      codemirrorSessionId: this.props.sessionId,
      codemirrorType: this.props.codemirrorType
    });
  }

  clearStatusBar() {
    this.props.registerStatusBar(EMPTY_STATE);
  }

}